"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FetchFetcher {
    fetchText(url) {
        return this.fetch(url)
            .then(r => r.text());
    }
    fetchJson(url) {
        return this.fetch(url)
            .then(r => r.json());
    }
    fetchArrayBuffer(url) {
        return this.fetch(url)
            .then(r => {
            if (r.ok) {
                return this.toArrayBuffer(r)
                    .catch(e => Promise.reject(e));
            }
            else {
                return Promise.reject(r.status + " " + r.statusText + " " + url);
            }
        });
    }
    fetch(url, options = { mode: 'cors' }) {
        return fetch(url, options)
            .catch(e => Promise.reject(e));
    }
    toArrayBuffer(response) {
        if (response.arrayBuffer) {
            return response.arrayBuffer();
        }
        else {
            // isomorphic-fetch does not support response.arrayBuffer
            return new Promise((resolve, reject) => {
                let chunks = [];
                //let bytes = 0;
                response.body.on('error', err => {
                    reject("invalid audio url " + err);
                });
                response.body.on('data', chunk => {
                    chunks.push(chunk);
                    //bytes += chunk.length;
                });
                response.body.on('end', () => {
                    resolve(Buffer.concat(chunks));
                });
            });
        }
    }
}
exports.FetchFetcher = FetchFetcher;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/util/fetcher.js
// module id = 271
// module chunks = 3